module.exports = "img/info-slide-1.fb1104.jpeg";